// frontend/src/components/code-editor/EvaluationPanel.tsx

import { DetailedCodeEvaluationResult } from '../../types/ai.types';

interface EvaluationPanelProps {
  result: DetailedCodeEvaluationResult | null;
  isLoading: boolean;
  error: string | null;
  onEvaluate: () => void;
  canEvaluate: boolean;
}

export function EvaluationPanel({ result, isLoading, error, onEvaluate, canEvaluate }: EvaluationPanelProps) {
  return (
    <div className="card evaluation-card">
      <div className="evaluation-header">
        <h3>AI Kod Değerlendirmesi</h3>
        <button
          type="button"
          className="lesson-btn primary sm"
          onClick={onEvaluate}
          disabled={isLoading || !canEvaluate}
        >
          {isLoading ? '⏳ Değerlendiriliyor...' : '🤖 Değerlendir'}
        </button>
      </div>

      {error && <p className="evaluation-error">{error}</p>}

      {result ? (
        <>
          <div className="evaluation-scores">
            <div className="evaluation-score">
              <div className="evaluation-score-value">{result.quality}</div>
              <div className="evaluation-score-label">Kod Kalitesi</div>
            </div>
            <div className="evaluation-score">
              <div className="evaluation-score-value">{result.logic}</div>
              <div className="evaluation-score-label">Mantık</div>
            </div>
            <div className="evaluation-score">
              <div className="evaluation-score-value">{result.readability}</div>
              <div className="evaluation-score-label">Okunabilirlik</div>
            </div>
          </div>
          {result.overallFeedback && (
            <p className="evaluation-overall-feedback">{result.overallFeedback}</p>
          )}
          {result.improvements.length > 0 && (
            <div className="evaluation-feedback">
              <h4>💡 İyileştirme Önerileri</h4>
              <ul>
                {result.improvements.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </div>
          )}
        </>
      ) : (
        !error && (
          <div className="evaluation-placeholder">
            <div className="evaluation-placeholder-icon">🤖</div>
            <p>Kodunu AI'a değerlendirmek için butona tıkla</p>
          </div>
        )
      )}
    </div>
  );
}
